export const content = {
  SET: 'content/SET',
  READY: 'content/READY'
}

export const authors = {
  ADD: 'authors/ADD'
}

export const events = {
  SET: 'events/SET'
}

export const posts = {
  CACHE: 'posts/CACHE',
  SET_TOTAL: 'posts/SET_TOTAL',
  SET_OFFSET: 'posts/SET_OFFSET',
  SET_OFFSET_FEATURED: 'posts/SET_OFFSET_FEATURED'
}

export const vector = {
  INITIALIZE: 'vector/INITIALIZE'
}

export const moves = {
  INCREMENT: 'moves/INCREMENT'
}



// WEBPACK FOOTER //
// ./src/store/mutations.js